import stateData from '../stateData';
import { useLayoutEffect, useState } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5map from "@amcharts/amcharts5/map";
import usLow from "@amcharts/amcharts5-geodata/usaAlbersLow"
import './map.css';

export const Map = () => {


    const [root, setRoot] = useState();
  const [map, setMap] = useState();
  const [currentState, setCurrentState] = useState();
  const [mapExpanded, setMapExpanded] = useState(true);

  useLayoutEffect(() => {
    const newRoot = am5.Root.new("map-container");
    const newMap = newRoot.container.children.push( 
      am5map.MapChart.new(newRoot, {
        zoomStep: 1.1
      }) 
    );    
    const polygonSeries = newMap.series.push(
      am5map.MapPolygonSeries.new(newRoot, {
        geoJSON: usLow,
        exclude: ["AK"]
      })
    );
    polygonSeries.mapPolygons.template.states.create("active", {
      fill: am5.color(0x5f22d9),//newRoot.interfaceColors.get("primaryButtonActive")
      stroke: am5.color(0xe5ddc8),
      strokeWidth: 1
    });
    polygonSeries.mapPolygons.template.states.create("upcoming", {
      fill: am5.color(0xA1E3F9),//newRoot.interfaceColors.get("primaryButtonActive")
      stroke: am5.color(0xe5ddc8),
      strokeWidth: 1
    });
    // polygonSeries.mapPolygons.template.states.create("hover", {
    //   fill: am5.color(0xe5ddc8)//newRoot.interfaceColors.get("primaryButtonActive")
    // });

    polygonSeries.mapPolygons.template.events.on("click", function(ev) {
     const dataContext = ev.target.dataItem.dataContext;

     if (dataContext && stateData[dataContext.name] && stateData[dataContext.name].active) {
        setCurrentState(dataContext.name);
        ev.target.states.apply("active")
        setTimeout(() => document.getElementById("statePictures").scrollTo({behavior: "smooth"}), 100);
     }
    });
    setMap(newMap);
    setRoot(newRoot);

    polygonSeries.data.setAll(Object.values(stateData))
    am5.array.each(polygonSeries.mapPolygons._values, function(data) {
      let dataContext = data._dataItem.dataContext;
      if (dataContext) {         

        if (dataContext.active) {
          data.states.apply("active")
        }
        if (dataContext.upcoming) {
          data.states.apply("upcoming")
        }
      }
    })
    polygonSeries.mapPolygons.template.setAll({
      tooltipText: "{name}",
      toggleKey: "hover",
      interactive: true
    });

    //polygonSeries.data.setAll(newData)
    return () => newRoot.dispose();
  }, []);

  return (
    <div id="map-container" style={{ maxWidth: "30em", margin: "1em auto", width: "100%", height: mapExpanded ? "60vh" : "0vh", maxHeight:"400px" }}></div>
  )
}